import { render, staticRenderFns } from "./portalRelatedImagesDrawer.vue?vue&type=template&id=db6c6446&scoped=true&lang=pug"
import script from "./portalRelatedImagesDrawer.vue?vue&type=script&lang=js"
export * from "./portalRelatedImagesDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6c6446",
  null
  
)

export default component.exports